import { useTeamsSelectOptions } from '../../../../shared/teams/hooks';
import type { SetProjectsFilter } from '../shared/types';

/**
 * Hook that fetches the teams, converts them into select options, manages the selected teams,
 *
 * @param {SetProjectsFilter} setFilters - The function to update the projects filter
 */
function useTeamsSelectOptionsWithFilterUpdate(setFilters: SetProjectsFilter) {
  const onUpdateFilters = (teamId: number[]) => setFilters((prevFilters) => ({
    ...prevFilters,
    teamId,
  }));

  const {
    isLoading,
    teamOptions,
    selectedTeamOptions,
    onTeamsSelected,
  } = useTeamsSelectOptions({ onTeamsChange: onUpdateFilters });

  return {
    isLoading,
    teamOptions,
    selectedTeamOptions,
    onTeamsSelected,
  };
}

export default useTeamsSelectOptionsWithFilterUpdate;
